import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Carolina M.',
    role: 'Madre de 2 hijos (8 y 11 años)',
    text: 'Sentía que perdía a mis hijos frente a las pantallas. Esta guía me dio las palabras exactas para poner límites sin gritar. En 4 días ya notamos la diferencia en la cena.',
    rating: 5
  }, {
    name: 'Valeria S.',
    role: 'Madre de un adolescente',
    text: 'Lo que más me gustó es que no sataniza la tecnología. Es muy realista. Logramos reducir 2 horas de uso diario sin peleas. Vale totalmente la pena.',
    rating: 5
  }, {
    name: 'Andrea P.',
    role: 'Madre primeriza',
    text: "Simple, directo y al grano. Me ayudó a establecer reglas claras desde el principio. Ahora tenemos 'zonas libres de pantallas' que todos respetamos.",
    rating: 5
  }];
  return <section className="py-8 bg-white border-y border-gray-100" data-id="element-209">
      <div className="container mx-auto px-4" data-id="element-210">
        <div className="text-center mb-8" data-id="element-211">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a1a2e] font-montserrat" data-id="element-212">
            Lo que dicen otras madres
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5 max-w-6xl mx-auto" data-id="element-213">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[#FAFAF8] p-5 rounded-2xl border border-gray-100 shadow-sm" data-id="element-214">
              <div className="flex gap-1 mb-3" data-id="element-215">
                {[...Array(t.rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#F97316] text-[#F97316]" data-id="element-216" />)}
              </div>
              <p className="text-gray-700 mb-4 italic leading-relaxed" data-id="element-217">
                "{t.text}"
              </p>
              <div data-id="element-218">
                <p className="font-bold text-[#1a1a2e]" data-id="element-219">{t.name}</p>
                <p className="text-sm text-gray-500" data-id="element-220">{t.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}